import React from 'react';
import { Plus, XCircle } from 'react-feather';
import max from 'lodash/max';
import noop from 'lodash/noop';
import find from 'lodash/find';

import { Input } from 'app/seedly-component-library';
import DropdownSelect from 'seedly-component-library/dropdown-select';

import {
  CREDENTIAL_LINK_MAP,
  CREDENTIAL_LINK_TYPE_LIST,
  CREDENTIAL_TITLE_MAP,
} from 'app/constants/profile';
import { credentialDropdownIcons } from 'theme';

const makeLinkOptions = (onClick = noop) => {
  return CREDENTIAL_LINK_TYPE_LIST.map(linkType => {
    return {
      title: CREDENTIAL_TITLE_MAP[linkType],
      value: linkType,
      onClick: () => onClick(linkType),
      icon: (
        <img
          alt="link"
          className="w-[18px] h-[18px] object-contain"
          src={credentialDropdownIcons[linkType]}
        />
      ),
    };
  });
};

const handleRemoveLink = (links, removeId, onChange) => {
  // Get Latest Id Form Links Ids
  const linkIds = Object.keys(links || {});
  const newFormLinks = {};

  let newLinkId = 0;
  linkIds.forEach(id => {
    if (id !== removeId) {
      newFormLinks[newLinkId] = { ...links[id] };
      newLinkId += 1;
    }
  });

  onChange(newFormLinks);
};

const handleAddLink = (links, onChange) => {
  let nextId = 0;
  let nextType = null;

  // Get Latest Id Form Links Ids
  const linkIds = Object.keys(links || {});

  // If alrd have max length
  if (linkIds.length >= CREDENTIAL_LINK_TYPE_LIST.length) {
    return null;
  }

  // Highest Id for nextId
  if (linkIds.length > 0) {
    nextId = parseInt(max(linkIds), 10) + 1;
  }

  // Get Uniq Type in Links
  const uniqueType = {};
  linkIds.forEach(linkId => {
    const linkType = links[linkId].type;
    uniqueType[linkType] = true;
  });

  // Get first absent social link
  CREDENTIAL_LINK_TYPE_LIST.forEach(type => {
    if (!uniqueType[type]) {
      nextType = type;
    }
  });

  // If have any absent social links
  if (nextType) {
    links[nextId] = {};
    links[nextId].value = '';
    links[nextId].type = nextType;
    onChange(links);
  }
};

const ProfileLinksInputRow = props => {
  const { links, onChange } = props;

  const arrayLinks = Object.keys(links).map(key => {
    links[key].id = key;
    return links[key];
  });

  return (
    <div className="flex lg:flex-row flex-col w-full gap-4">
      <div className="flex justify-end lg:w-[130px] w-auto">
        <p className="text-sm font-bold">Social Links</p>
      </div>
      <div className="flex flex-col w-full gap-2">
        {arrayLinks.map(link => {
          const { type, id, value } = link;
          const linkOptions = makeLinkOptions(t => {
            links[id].type = t;
            onChange(links);
          });

          const defaultSelected = find(linkOptions, { value: type });

          return (
            <div className="flex gap-6 items-center w-full" key={id}>
              <Input
                size="lg"
                width="100%"
                value={value}
                onChange={e => {
                  links[id].value = e.target.value;
                  onChange(links);
                }}
                innerInputSpacing="none"
                prefix={
                  <div className="flex gap-1 items-center">
                    <DropdownSelect
                      items={linkOptions}
                      defaultSelectedItem={defaultSelected}
                      handleSelectedItemchange={item => {
                        item.selectedItem.onClick();
                      }}
                      variant="white"
                    />
                    <p>{CREDENTIAL_LINK_MAP[type]}</p>
                  </div>
                }
              />
              <XCircle
                size={15}
                style={{ cursor: 'pointer' }}
                onClick={() => handleRemoveLink(links, id, onChange)}
              />
            </div>
          );
        })}
        <div
          className="flex items-center cursor-pointer"
          onClick={() => handleAddLink(links, onChange)}
        >
          <Plus className="mr-1.5 text-blue-500" size={22} />
          <p className="text-blue-500">Add Links</p>
        </div>
      </div>
    </div>
  );
};

export default ProfileLinksInputRow;
